import {Component, OnInit} from '@angular/core';
import {Handler} from "src/app/common/handler";
import {ConnectionType, DataType} from "@flowmaps-com/flowmaps-typescriptmodels";
import {BaseMeasurementChartComponent} from "../base-measurement-chart";
import {ChartOptionType} from "../../dashboard/dashboard.types";
import {scatterExclusiveTooltipPlugin, syncScatterYAxisPlugin} from "../bar-chart/bar-chart.component";
import {AppContext} from "../../../app-context";

@Component({
  selector: 'app-water-chart',
  templateUrl: './water-chart.component.html',
  styleUrls: ['./water-chart.component.scss']
})
@Handler()
export class WaterChartComponent extends BaseMeasurementChartComponent implements OnInit {
  chartOptionType: ChartOptionType = ChartOptionType.Water;
  mainConsumptionType: DataType = DataType.waterConsumption;
  mainConnectionType: ConnectionType = ConnectionType.Water;
  connectionTypes: ConnectionType[] = [ConnectionType.Water];

  ngOnInit() {
    super.ngOnInit();
    // Water is measured as consumption/volume; a saved power option from older
    // dashboards must not enable an electrical power series on this chart.
    this.options.showPower = false;
    this.options.showPowerForEan = null;
  }

  openModal() {
    super.openModal(WaterChartComponent);
  }

  measurementTypes = (): DataType[] => {
    let baseMeasurements = [DataType.waterConsumption];
    if (this.groupByEntityIdEnabled() || this.onlyMetersSelected) {
      baseMeasurements = baseMeasurements.concat([DataType.waterIntermediateConsumption]);
    }
    return baseMeasurements;
  };

  measurementIntermediateLink = (): Map<DataType, DataType[]> => {
    return new Map<DataType, DataType[]>().set(DataType.waterConsumption, [DataType.waterIntermediateConsumption]);
  };

  consumptionProductionLink = (): Map<DataType, DataType> => new Map<DataType, DataType>();

  measurementTypesMapped = (): {[key: string]: DataType[]} => {
    return {
      [DataType.waterConsumption]: [DataType.waterConsumption],
      [DataType.waterIntermediateConsumption]: [DataType.waterIntermediateConsumption]
    };
  }

  productionDataTypesMapped = (): {[key: string]: DataType[]} => {
    const measurementTypes = this.productionDataTypes();
    return {
      [measurementTypes[0]]: measurementTypes
    };
  }

  powerDataTypeMapped = (): {[key: string]: DataType} => ({});

  plugins = [scatterExclusiveTooltipPlugin, syncScatterYAxisPlugin];
  protected readonly AppContext = AppContext;
}
